/**
 * A tool call "has no user-facing query" when the input query is absent, empty,
 * or the Typesense wildcard `*`. The backend emits `*` when the agent called the
 * tool with only structured filters (supplier id, commodity group id, …), so
 * rendering a sentence like "… that include '*'" is nonsensical. The renderer
 * should fall back to a query-less i18n key in that case.
 */
export const isWildcardOrEmptyQuery = (query: unknown): boolean => {
  if (typeof query !== 'string') return true;

  const trimmedQuery = query.trim();
  return trimmedQuery === '' || trimmedQuery === '*';
};
